import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import i18n from "../i18n";
import parcours from "./modules/parcours.js";
import authAdmin from "./modules/authAdmin.js";
import listCoureurs from "./modules/listCoureurs.js";
import pcCoursePassages from "./modules/pcCoursePassages.js";
import listInscriptions from "./modules/listInscriptions.js";
import ui from "./modules/ui.js";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mobileBreakpoint: 1200,
    viewportWidth: typeof window !== "undefined" ? window.innerWidth : 1201,
    base_url: "https://sportips.fr/api/v1/unique_event/endpoints",
    isAppLoaded: false,
    hide_nb_inscrits: true,
    module: {},
    map_settings: {
      mode: [
        { name: "topo", link: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png" },
        { name: "terrain", link: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" },
        { name: "map", link: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" },
      ],
      selected_mode: 0,
    },
    refreshIntervals: [],
    refreshTempsCourseIntervals: [],
    currentTime: Date.now(),
    timeIntervalId: null,
    loading: false,
    showParticipantsTab: true,
    live_en_cours: true,
    selected_live_course: "",
    last_live_tab: "participants",
    refresh_time_live: 20000,
    refresh_time_carte: 20000,
    date_selected_course: "",
    heure_selected_course: "",
    fin_selected_course: "NON",
    logged: false,
  },
  mutations: {
    initModule(state, m) {
      state.module = m;
    },
    initAdmin(state, a) {
      state.admin = a;
    },
    setParcours(state, p) {
      state.module.list_parcours = p;
    },
    setInscriptions(state, i) {
      state.module.list_inscriptions = i;
    },
    setResultats(state, r) {
      state.module.resultats = r;
    },
    setLive(state, l) {
      state.module.live = l;
    },
    setLoading(state) {
      state.loading = true;
    },
    unsetLoading(state) {
      state.loading = false;
    },
    setFondCarte(state, f) {
      state.map_settings.selected_mode = f;
    },
    clearRefreshIntervals(state) {
      for (var i = 0; i < state.refreshIntervals.length; i++) {
        clearInterval(state.refreshIntervals[i]);
      }
      state.refreshIntervals = [];
    },
    clearRefreshTempsCourseIntervals(state) {
      for (var i = 0; i < state.refreshTempsCourseIntervals.length; i++) {
        clearInterval(state.refreshTempsCourseIntervals[i]);
      }
      state.refreshTempsCourseIntervals = [];
    },
    updateCurrentTime(state) {
      state.currentTime = Date.now();
    },
    startTimeInterval(state) {
      if (state.timeIntervalId) {
        return; // Interval déjà démarré
      }
      state.timeIntervalId = setInterval(() => {
        state.currentTime = Date.now();
      }, 1000);
    },
    stopTimeInterval(state) {
      if (state.timeIntervalId) {
        clearInterval(state.timeIntervalId);
        state.timeIntervalId = null;
      }
    },

    set_refresh_time_live(state, t) {
      state.refresh_time_live = parseInt(t) * 1000;
    },
    set_refresh_time_carte(state, t) {
      state.refresh_time_carte = parseInt(t) * 1000;
    },
    setVisibilityParticipantsTab(state) {
      if (state.module.base == 'MAXIRACE26') {
        state.showParticipantsTab = false;
        return;
      }

      var start_date = state.module.date_course;
      if (!start_date) return;
      start_date = start_date.split("-");
      var formated_date = new Date(
        parseInt(start_date[2], 10),
        parseInt(start_date[1], 10) - 1,
        parseInt(start_date[0], 10),
        10
      ).getTime();
      var current_date = Date.now();
      if (current_date >= formated_date || state.module.live_en_cours) {
        state.showParticipantsTab = false;
      }
    },
    setIsAppLoaded(state) {
      state.isAppLoaded = true;
    },
    setHideNbInscrits(state, base) {
      if (state.authAdmin.isLogged) {
        state.hide_nb_inscrits = false;
        return;
      }
      state.hide_nb_inscrits = base.includes("MAXIRACE26");
    },
    setViewportWidth(state, width) {
      state.viewportWidth = width;
    },
  },
  actions: {
    async fetchModule({ commit, state }, base) {
      commit("setLoading");
      try {
        const { data } = await axios.get(
          `${state.base_url}/module/get.php?base=${encodeURIComponent(base)}`
        );
        if (data) {
          commit("initModule", data);
          return data;
        }
      } catch (error) {
        console.error("Erreur lors de la récupération du module:", error);
        return null;
      } finally {
        commit("unsetLoading");
      }
      return null;

    },
    async fetchAdmin({ commit, state }) {
      const { data } = await axios.get(
        `${state.base_url}/admin/get.php?id=${state.module.id}`
      );
      commit("initAdmin", data);
      commit("unsetLoading");
    },
    async loadParcoursList({ commit, dispatch }) {
      commit("setLoading");
      await dispatch("parcours/fetchList");
      commit("unsetLoading");
    },
    async initAdminAndParcours({ state, dispatch }) {
      if (!state.module.id) return;
      await dispatch("fetchAdmin");
      await dispatch("loadParcoursList");
    },
  },
  getters: {
    isMobile(state) {
      return state.viewportWidth <= state.mobileBreakpoint;
    },

  },

  modules: {
    parcours,
    authAdmin,
    listCoureurs,
    pcCoursePassages,
    listInscriptions,
    ui,
  },
}); 
